import React from 'react';
import ElfoVerseMascot from '../../assets/elfoverse-mascot.png';
import CustomTooltip from '../CustomTooltip';
import { CONNECTION_OPTIONS, TOOLTIPS } from './constants';

const ExistingConnection = ({ connectionOption, onOptionChange }) => {
  return (
    <>
      <div className="mascot">
        <img src={ElfoVerseMascot} alt="ElfoVerse Mascot" />
      </div>
      <div className="existing-options-wrapper">
        <h2>Connect WhatsApp Business Platform</h2>
        <p className="description">
          Select your preferred method to connect with the WhatsApp Business Platform (API).
        </p>

        <div className="radio-options">
          <label className="radio-label">
            <input
              type="radio"
              name="connection-type"
              value={CONNECTION_OPTIONS.EXISTING_ELFOA2P}
              checked={connectionOption === CONNECTION_OPTIONS.EXISTING_ELFOA2P}
              onChange={onOptionChange}
            />
            <span className="custom-radio"></span>
            An existing WhatsApp Business Platform (API) account with elfoA2P
          </label>

          <label className="radio-label">
            <input
              type="radio"
              name="connection-type"
              value={CONNECTION_OPTIONS.EXISTING_BSP}
              checked={connectionOption === CONNECTION_OPTIONS.EXISTING_BSP}
              onChange={onOptionChange}
            />
            <span className="custom-radio"></span>
            An existing WhatsApp Business Platform (API) account from another BSP{' '}
            <CustomTooltip placement="right" message={TOOLTIPS.EXISTING_BSP} />
          </label>
        </div>
      </div>
    </>
  );
};

export default ExistingConnection;
